// extracted by mini-css-extract-plugin
export default {"wrapper":"AccessibilityElement__wrapper--1kJ","inline":"AccessibilityElement__inline--Ux2","focused":"AccessibilityElement__focused--2cI"};